import { GlobalStoreContextType } from "../../../../context/GlobalStoreContext";
import { Team } from "../../../../models/Team";

export const isGCOnJobsite = (context: GlobalStoreContextType, team: Team) => {
    if (context.currentProjectInfo.owning_team_id == team.id) {
        return true;
    }

    return false;
};

export const isTradeOnJobsite = (context: GlobalStoreContextType, team: Team) => {
    if (
        context.teamsForProject(context.currentProjectInfo.id).some((v) => v.id === team.id) &&
        team.id != context.currentProjectInfo.owning_team_id
    ) {
        return true;
    }

    return false;
};

export const isVendorOnJobsite = (context: GlobalStoreContextType, team: Team) => {
    if (context.vendorsForProject(context.currentProjectInfo.id).some((v) => v.id === team.id)) {
        return true;
    }

    return false;
};
